"use strict";

exports.__esModule = true;
var _DeviceConnectionStatusContext = require("./DeviceConnectionStatusContext");
Object.keys(_DeviceConnectionStatusContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceConnectionStatusContext[key]) return;
  exports[key] = _DeviceConnectionStatusContext[key];
});